import * as _ from 'underscore';

import { Dataset } from '..';

import { ReportInput } from './report-input';
import reportInputs from './report-input';

/*
Defines reports and their visibility for what users and/or for what org/brand
Similar in purpose to EdcServerLib/src/Reporting/Dataset.cs
TODO: This security should come from the backend, not the frontend where it can be manipulated by savvy users
*/
export class Report {
   static reports: Report[];

   id:string;
   title:string;
   admin:boolean = false;
   orgSlug:string = null;
   brandSlugs:string[];
   roles:string = null;
   inputs:ReportInput[];
   datasetIds:string[];
   datasets:Dataset[];

   constructor(report: any) {
      this.id = report.id;
      this.title = report.title;
      this.datasetIds = report.datasetIds;

      if (report.admin) {
         this.admin = report.admin;
      }

      if (report.orgSlug) {
         this.orgSlug = report.orgSlug;
      }

      if (report.brandSlugs) {
         this.brandSlugs = report.brandSlugs;
      }

      if (report.roles) {
         this.roles = report.roles;
      }

      if (report.inputs) {
         this.inputs = report.inputs;
      } else {
         this.inputs = [
            reportInputs.EventIds,
            reportInputs.StartDate,
            reportInputs.EndDate
         ];
      }
   }
}

Report.reports = [
   new Report({
      id: 'demographics',
      title: 'Demographics',
      datasetIds: ['gender', 'age-range', 'participant-map']
   }),
   new Report({
      id: 'participant-total',
      title: 'Participant Totals',
      datasetIds: ['participant-total'],
      inputs: [
         reportInputs.EventIds,
         reportInputs.GuestTypeIds,
         reportInputs.StartDate,
         reportInputs.EndDate
      ]
   }),
   new Report({
      id: 'nps',
      title: 'Net Promoter Score',
      orgSlug: 'fca*',
      datasetIds: ['nps-totals', 'nps-distribution-pre', 'nps-distribution-post'],
      inputs: [
         reportInputs.FcaBrand,
         reportInputs.NpsScope,
         reportInputs.FcaConsumerType,
         reportInputs.EventIds
      ]
   }),
   new Report({
      id: 'prereg-total',
      title: 'PreRegistration Totals',
      datasetIds: ['prereg-total'],
      inputs: [
         reportInputs.EventIds,
         reportInputs.GuestTypeIds,
         reportInputs.StartDate,
         reportInputs.EndDate
      ]
   }),
   new Report({
      id: 'media-total',
      title: 'Media Totals',
      datasetIds: ['media-total']
   }),
   new Report({
      id: 'prereg-primary-secondary',
      title: 'Primaries and Secondaries',
      datasetIds: ['prereg-primary-secondary'],
      inputs: [
         reportInputs.EventIds,
         reportInputs.GuestTypeIds,
         reportInputs.StartDate,
         reportInputs.EndDate
      ]
   }),
   new Report({
      id: 'source-total',
      title: 'Invite Source Totals',
      datasetIds: ['source-total'],
      inputs: [
         reportInputs.EventIds,
         reportInputs.GuestTypeIds,
         reportInputs.StartDate,
         reportInputs.EndDate
      ]
   }),
   new Report({
      id: 'survey-summary',
      title: 'Survey Summary',
      datasetIds: ['survey-summary'],
      inputs: [
         reportInputs.SurveyItems,
         reportInputs.EventIds,
         reportInputs.GuestTypeIds,
         reportInputs.StartDate,
         reportInputs.EndDate
      ]
   }),
   new Report({
      id: 'email-summary',
      title: 'Email Summary',
      datasetIds: ['email-summary'],
   }),
   new Report({
      id: 'email-clicks',
      title: 'Email Clicks',
      datasetIds: ['email-clicks'],
   }),
   new Report({
      id: 'device-usage',
      title: 'Device Usage',
      admin: true,
      datasetIds: ['device-usage'],
      inputs: [
         reportInputs.BrandId,
         reportInputs.CampaignId,
         reportInputs.EventIds,
         reportInputs.StartDate,
         reportInputs.EndDate
      ]
   }),
   new Report({
      id: 'transfer-status',
      title: 'Transfer Status',
      admin: true,
      datasetIds: ['transfer-status'],
      inputs: [
         reportInputs.BrandIds,
         reportInputs.StartDate,
         reportInputs.EndDate
      ]
   }),
   new Report({
      id: 'fca-summary',
      title: 'FCA Summary',
      datasetIds: ['fca-summary'],
      orgSlug: 'fca',
      inputs: [
         reportInputs.Unique,
         reportInputs.EventIds,
         reportInputs.StartDate,
         reportInputs.EndDate
      ]
   }),
   new Report({
      id: 'fca-summary-canada',
      title: 'FCA Summary',
      datasetIds: ['fca-summary-canada'],
      orgSlug: 'fca-canada'
   }),
   new Report({
      id: 'fca-ram-rodeo',
      title: 'FCA Ram Rodeo',
      datasetIds: ['fca-ram-rodeo'],
      brandSlugs: ['fca-commercial-national'],
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager,ReportUser',
      inputs: [
         reportInputs.FcaRegSource
      ]
   }),
   new Report({
      id: 'fca-commercial-national',
      title: 'FCA Commercial National',
      datasetIds: ['fca-commercial-national'],
      brandSlugs: ['fca-commercial-national'],
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager,ReportUser',
      inputs: []
   }),
   new Report({
      id: 'fca-sales-match',
      title: 'FCA Sales Match',
      orgSlug: 'fca',
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager',
      datasetIds: ['fca-sales-match'],
      inputs: [
         reportInputs.DateRange,
         reportInputs.EventIds
      ]
   }),
   new Report({
      id: 'velocity-report',
      title: 'Throughput',
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager,ReportUser',
      datasetIds: ['velocity', 'velocity-hourly']
   }),
   new Report({
      id: 'fca-goals-actuals',
      title: 'FCA Goals & Actuals',
      datasetIds: ['fca-goals-actuals'],
      orgSlug: 'fca*'
   }),
   new Report({
      id: 'fca-dashboard-cytd',
      title: 'FCA Dashboard CYTD',
      brandSlugs: ['fca-alfa-romeo', 'fca-business-center', 'fca-chrysler', 'fca-dodge', 'fca-fiat', 'fca-jeep', 'fca-multi-brand', 'fca-ram'],
      roles: 'SuperAdmin,OrgAdmin,BrandManager',
      datasetIds: ['fca-dashboard-cytd'],
      inputs: [
         reportInputs.Year
      ]
   }),
   new Report({
      id: 'fca-sales-match-export',
      title: 'FCA Sales Match Export',
      brandSlugs: ['fca-alfa-romeo', 'fca-business-center', 'fca-chrysler', 'fca-dodge', 'fca-fiat', 'fca-jeep', 'fca-multi-brand', 'fca-ram'],
      roles: 'SuperAdmin,OrgAdmin,BrandManager',
      datasetIds: ['fca-sales-match-export'],
      inputs: []
   }),
   new Report({
      id: 'fca-sales-match-autoshows-export',
      title: 'FCA Sales Match Export',
      brandSlugs: ['fca-auto-shows'],
      roles: 'SuperAdmin,OrgAdmin,BrandManager',
      datasetIds: ['fca-sales-match-autoshows-export'],
      inputs: []
   }),
   new Report({
      id: 'fca-experience-totals',
      title: 'FCA Experience Totals',
      datasetIds: ['fca-experience-totals'],
      orgSlug: 'fca',
      inputs: [
         reportInputs.Unique,
         reportInputs.EventIds
      ]
   }),
   new Report({
      id: 'multi-demo-line-chart',
      title: 'Throughput Line Chart Demo',
      roles: 'SuperAdmin',
      datasetIds: ['velocity-hourly-demo1']
   }),
   new Report({
      id: 'multi-demo-bar-chart',
      title: 'Throughput Bar Chart Demo',
      roles: 'SuperAdmin',
      datasetIds: ['velocity-hourly-demo2']
   }),
   new Report({
      id: 'fca-totals-by-brand',
      title: 'FCA Totals By Brand',
      datasetIds: ['fca-totals-by-brand'],
      brandSlugs: ['fca-multi-brand','fca-auto-shows'],
      inputs: [
         reportInputs.EventIds,
         reportInputs.StartDate,
         reportInputs.EndDate
      ]
   })
];
